// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3Gtc-","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__trYnd"};